import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormBuilderFields',
  props: [
	"is_logged_in", "email", 'show_country', 'show_county', 'show_city', 
	'show_postal', 'show_tax', 'show_phone_no', 'show_company', 
	'show_anonymous_donation', 'enable_test_card_information', "strings",
	'use_form_builder', 'form_builder_config', 'formFields'
],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const fieldNameMap: Record<string, string> = {
	'first_name': 'first_name',
	'last_name': 'last_name',
	'email': 'email',
	'phone': 'phone',
	'company': 'company',
	'address': 'address',
	'city': 'city',
	'state': 'state',
	'zip': 'zip',
	'country': 'country',
	'tax': 'tax',
	'anonymous_donation': 'anonymous_donation'
};

const useFormBuilder = computed(() => {
	return props.use_form_builder === true && (props.form_builder_config?.fields?.length > 0 || props.formFields?.length > 0);
});

const computedFormFields = computed(() => {
	if (!useFormBuilder.value) return [];
	return props.form_builder_config?.fields || [];
});

const displayFields = computed(() => {
	if (props.formFields && Array.isArray(props.formFields) && props.formFields.length > 0) {
		return props.formFields;
	}
	if (computedFormFields.value && Array.isArray(computedFormFields.value) && computedFormFields.value.length > 0) {
		return computedFormFields.value;
	}
	return [];
});

const getStoreKey = (field: any): string => {
	return fieldNameMap[field.name] || field.name;
};

const setStoreFieldValue = (field: any, value: any) => {
	store.billing_fields[getStoreKey(field)] = value;
};

const getFieldColumnClass = (field: any) => {
	if (field.name === 'first_name' || field.name === 'last_name') {
		return 'wpcm-col-md-6';
	}
	return 'wpcm-col-md-12';
};

const initializeFields = () => {
	const fields = displayFields.value;
	if (!fields || !fields.length) return;

	for (const field of fields) {
		const key = getStoreKey(field);
		if (!(key in store.billing_fields)) {
			if (field.type === 'checkbox' || field.type === 'anonymous_donation') {
				store.billing_fields[key] = false;
			} else {
				store.billing_fields[key] = '';
			}
		}
	}

	if (props.is_logged_in && props.email) {
		store.billing_fields.email = props.email;
	}
};

onMounted(() => {
	initializeFields();
});

const __returned__ = { store, props, fieldNameMap, useFormBuilder, computedFormFields, displayFields, getStoreKey, setStoreFieldValue, getFieldColumnClass, initializeFields }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})